export default "__VITE_ASSET__DQnmO2jt__";